@if (tyre) {
  {{ tyre?.producer?.name }} {{ tyre?.tread_name }} {{ tyre?.load_index || '' }}{{ tyre?.speed_index || '' }}
  <app-tyre-size [tyre]="tyre"></app-tyre-size>
}
